// extracted by mini-css-extract-plugin
export default {"TextLink":"TextLink_TextLink__yDGCA","TextLink__black":"TextLink_TextLink__black__p0UVu","TextLink__white":"TextLink_TextLink__white__snNkC"};